import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Subscribe from './views/Subscribe.vue'
import RedirectPage from './views/RedirectPage.vue'
import Errorpage from './views/Errorpage.vue'
import Ifexistredirct from './components/Ifexistredirct.vue'
import GENAME from './views/GENAME.vue'
import ErrorRedirectpage from './views/ErrorRedirectPage.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',     
      name: 'home',      
      component: Home
    },
    {
      path: '/G',
      name: 'GENAME',
      component: GENAME
    },
    {
      path: '/Error',
      name: 'Error',
      component: Errorpage
    },
    {
      path: '/subscribe/:id/:providercount?',
      name: 'subscribe',
      component: Subscribe
    },
    {
      path: '/errortoredirect',
      name: 'errorredirectpage',
      component: ErrorRedirectpage
    },
    {
      path: '/redirectpage',
      name: 'redirectpage',
      component: RedirectPage
    },
    {
      path: '/redirectpageifexist/:email',
      name: 'redirectpageifexist',
      component: Ifexistredirct
    },
    
  ]
})
